module.exports = __WEBPACK_EXTERNAL_MODULE__portfolio_navbar_46093d92__;